module.exports = __webpack_public_path__ + "img/08-sues-xd-logo.34cdc316.png";